import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import { initPWA } from './bootstrap/pwa'
import { initSentry } from './lib/sentry'
import { initDateYearGuard } from './bootstrap/dateYearGuard'
// 2026-06-14 보안 fix: queryClient 별도 모듈 (순환 import 방지, authStore 도 import)
import { queryClient } from './lib/queryClient'

// Sentry 초기화 (Phase K2-3, env 미설정 시 자동 비활성)
initSentry()

// PWA 서비스 워커 등록 + 포그라운드 푸시 핸들러
initPWA()

// 날짜 입력 연도 4자리 전역 가드 (브라우저가 6자리까지 허용한다)
initDateYearGuard()

// GPS 자동 갱신 제거 (2026-04-17 정책 변경)
// - 모바일 로그인/업무에서는 GPS 자동 수집 X
// - QR 코드 스캔 시에만 GPS 수집 → 생산처 위치 매칭 + 이탈 감지
// axios 인터셉터의 X-GPS-* 헤더 자동 첨부 로직도 비활성화됨

// 배포 후 캐시된 HTML이 없어진 JS 청크를 요청할 때 자동 새로고침
window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

// queryClient → lib/queryClient.js 로 분리 (2026-06-14)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
